<template>
  <div>
    <div class="mb-2">
      <vs-input
        v-validate="'required|email|min:3'"
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Email"
        v-model.trim="email"
        class="w-full"
      />
      <span class="text-danger text-sm">{{ errors.first("email") }}</span>
    </div>

    <div class="pt-4">
      <vs-input
        v-validate="'required|min:8|max:32'"
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Password"
        v-model="password"
        class="w-full"
        @keyup.enter="firebaseLogin"
      />
      <span class="text-danger text-sm">{{ errors.first("password") }}</span>
    </div>

    <div class="flex flex-wrap justify-between my-5">
      <vs-checkbox v-model="checkbox_remember_me" class="mb-3" @change="remember(checkbox_remember_me)"
        >Recuérdame</vs-checkbox
      >
      <router-link :to="`/pages/forgot-password${this.validateParamEmail}`">Olvido la contraseña?</router-link>
    </div>
    <vs-button class="float-right w-full" :disabled="!validateForm" @click="firebaseLogin">Iniciar sesión</vs-button>
  </div>
</template>

<script>
import { CLIENT_SECRET } from "@/constants";

import login from "@/mixins/login";

import { Validator } from "vee-validate";
const dict = {
  custom: {
    email: {
      required: "Ingrese el Email",
      email: "El campo email debe ser ser un email válido"
    },
    password: {
      required: "Ingrese el password",
      min: "El pasword debe contener mínimo 8 carácteres.",
      max: "El password no debe contener más de 32 carácteres."
    }
  }
};

Validator.localize("en", dict);

export default {
  mixins: [login],
  data() {
    return {
      // email: process.env.VUE_APP_EMAIL,
        email: localStorage.getItem("email") || process.env.VUE_APP_EMAIL,
        password: process.env.VUE_APP_PASSWORD,
    //   email: undefined,
    //   password: undefined,
      checkbox_remember_me: localStorage.getItem("check_remember") === "true",
      clientSecret: CLIENT_SECRET
    };
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.email !== undefined &&
        this.password !== undefined &&
        this.email !== "" &&
        this.password !== ""
      );
    },
    validateParamEmail() {
      if (this.email !== undefined) {
        return this.email.length > 0 ? `/${this.email}` : "";
      }
      return "";
    }
  },
  methods: {
    remember(checkbox_remember_me) {
      if (checkbox_remember_me) {
        if (this.email.trim !== "") {
          localStorage.setItem("email", this.email);
          localStorage.setItem("check_remember", true);
        }
      } else {
        const email = localStorage.getItem("email");
        if (email) localStorage.removeItem("email");
        localStorage.setItem("check_remember", false);
      }
    },
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        this.$vs.notify({
          title: "Login Attempt",
          text: "You are already logged in!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }
      return true;
    },
    validateData(email, password) {
      const condition1 = email !== undefined && password !== undefined;
      const condition2 = email.trim().length > 0 && password.trim().length > 0;
      return condition1 && condition2;
    },
    firebaseLogin() {
      this.$vs.loading();

      if (!this.validateData(this.email, this.password)) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Credenciales",
          text: "Ingrese el email y el password.",
          position: "top-right",
          color: "warning"
        });
        return;
      }

      let data = {
        email: this.email,
        password: this.password
      };

      this.$store
        .dispatch("firebaseAuth/login", data)
        .then(user => {
          this.loginApi(user);
        })
        .catch(error => {
          console.warn("firebaseLogin error:", error);
          this.$vs.notify({
            title: "Credenciales",
            text: "Credenciales incorrectas",
            position: "top-right",
            color: "warning"
          });
          this.$vs.loading.close();
        });
    },

    // Google login
    loginWithGoogle() {
      this.$store.dispatch("auth/loginWithGoogle", {
        notify: this.$vs.notify
      });
    },

    // Facebook login
    loginWithFacebook() {
      this.$store.dispatch("auth/loginWithFacebook", {
        notify: this.$vs.notify
      });
    },

    // Twitter login
    loginWithTwitter() {
      this.$store.dispatch("auth/loginWithTwitter", {
        notify: this.$vs.notify
      });
    },

    // Github login
    loginWithGithub() {
      this.$store.dispatch("auth/loginWithGithub", {
        notify: this.$vs.notify
      });
    },
    registerUser() {
      if (!this.checkLogin()) return;
      this.$router.push("/pages/register").catch(() => {});
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
